import { UseFormInput } from '@mantine/form';
import { FC } from 'react';
import { UnderwritingForm } from '../components/SimulationContent/UnderwritingForm';
import { CURRENCIES, SIMULATION_STATUSES, STATUS_ACTIONS } from '../config';
import { isOneOf } from './isOneOf';

export type FormValues = Record<string, any>;

export interface StatusFormMapping {
  component: FC;
  formConfig: UseFormInput<FormValues>;
  availableActions: STATUS_ACTIONS[];
}

export const statusFormConfig: Partial<Record<SIMULATION_STATUSES, StatusFormMapping>> = {
  [SIMULATION_STATUSES.AWAITING_UW_DECISION]: {
    component: UnderwritingForm,
    formConfig: {
      initialValues: {
        approved_amount: null,
        currency: null,
      },
      validate: (values) => {
        const errors: { currency?: string; approved_amount?: string } = {};
        const hasAmount = values.approved_amount != null && values.approved_amount !== '';
        const hasCurrency = !!values.currency;

        if (hasAmount || hasCurrency) {
          if (!hasCurrency) {
            errors.currency = 'Currency is required';
          } else if (!isOneOf(values.currency, CURRENCIES)) {
            errors.currency = 'Unsupported currency';
          }

          if (!hasAmount) {
            errors.approved_amount = 'Approved amount is required';
          }
        }

        return errors;
      },
      transformValues: (values) => {
        return {
          currency: values.currency || null,
          approved_amount: typeof values.approved_amount === 'number' ? values.approved_amount : null,
        };
      },
    },
    availableActions: [STATUS_ACTIONS.PASS_UW],
  },
};
